import {makeGetSpecialtiesSubSpecialtiesDentalGuide} from 'main/factories/usecases';
import {OdontoSpecialtiesParams} from './types';

async function getOdontoSpecialties(params: OdontoSpecialtiesParams) {
	const response = await makeGetSpecialtiesSubSpecialtiesDentalGuide().get(params);
	if (!response.especialidades || response.especialidades.length === 0) {
		return [];
	}
	return response.especialidades;
}

export {getOdontoSpecialties};
